<template>
  <div class="about_header">
      <div class="container flex column wc-lg">
         <h1 class="uppercase f-38 bold">{{ content.title }}</h1>
        <div class="about_header__editor" v-html="content.content"></div>
      </div>
         <div  class="about_header__img_wrapper">
             <div class="about_header__img_wrapper--overlay bg-overlay">
                 
             </div>
             <picture>
            <source media="(max-width: 767px)" :srcset="content.images[0].devices.mobile">
            <source media="(max-width: 1023px)" :srcset="content.images[0].devices.tablet">
            <img :src="content.images[0].devices.desktop" data-scroll data-scroll-speed="-1.7"   :alt="$route.name == 'PageViewRouter_ge' && content.seo_keywords_ge ? content.seo_keywords_ge : $route.name == 'PageViewRouter_en' && content.seo_keywords_en ? content.seo_keywords_en : ''" class="cover pos_abs">
            </picture>
     </div>


  </div>
</template>

<script>
import resize_handler from '@/mixins/resize_handler';
export default {
    mixins: [resize_handler], props: ['contentData'],
    data(){
        return {

        }
    },
    mounted(){
    },
    computed: {
        content(){
            return _.get(this.contentData, 'data.list[0]');
        }
    }
}
</script>


<style lang="scss" scoped>
.about_header__editor{
    &::v-deep{
        p, span, strong, h1, h2, h3, h4, h5, h6{
            font-size: 18px;
            line-height: 24px;
            @media (max-width: 767px){
                font-size: 14px;
            }
        }
    }
}
</style>
